import { AssessmentStepKeys } from '@/enums'
import { makeBusinessTypeSubmitValue } from '../../helpers'
import { ConditionalOfferAssessment } from './BasePage'

interface StepProps {
  [key: string]: {
    categoryId?: string
    helperText?: string
  }
}

interface Messages {
  helperText: string
}

const contentAssessmentSteps = [
  AssessmentStepKeys.businessTypeAi,
  AssessmentStepKeys.businessTypeConfirmationAi,
  AssessmentStepKeys.businessTypeMainSelectionAi,
  AssessmentStepKeys.companyFoundedDateLead,
  AssessmentStepKeys.approxRevenue,
  AssessmentStepKeys.inventory,
  AssessmentStepKeys.companyDetails,
]

const categoryId = 'CO'

const makeSubmitValues = () => {
  return function transform<T>(values: T): T {
    const typedValues = values as any
    return {
      ...values,
      lastYearFinances: typedValues.approxRevenue,
      locationRent: typedValues.inventory,
      businessType: makeBusinessTypeSubmitValue(typedValues.businessType),
      companyFoundedDate: typedValues.companyFoundedDateLead,
    } as T
  }
}

const makeStepProps = (messages: Messages): StepProps => ({
  [AssessmentStepKeys.businessTypeConfirmationAi]: {
    categoryId,
  },
  [AssessmentStepKeys.approxRevenue]: {
    helperText: messages.helperText,
  },
})

export const ContentConditionalOffer = () => (
  <ConditionalOfferAssessment
    categoryId={categoryId}
    makeStepProps={makeStepProps}
    stepKeys={contentAssessmentSteps}
    transformSubmitValues={makeSubmitValues()}
  />
)
